import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../constant/TYPE";
import Notepad from "./notepad/Notepad";
import SubmitButtons from "../../../../questionInspection/presentational/body/input/numberKeypad/submitButtons/SubmitButtons";
import KeypadChangeButton from "../../../../learning/presentational/body/input/notepad/submitButtons/KeypadChangeButton";

const Input = () => {

  const deviceInfo = useSelector( state => state.deviceInfo );

  return (
    <div className={ clsx( 'learningTail', TYPE.DEVICE.PAD === deviceInfo.type && 'on' ) }>
      <div className="onlyButtonBox" />
      <Notepad><SubmitButtons><KeypadChangeButton /></SubmitButtons></Notepad>
    </div>
  );

};

export default Input;
